// src/pages/controlRondas/ControlRondas.jsx
import "./controlRondas.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import RoutesModule from "../../components/rondas/RoutesModule";
import { useSidebarState } from "../../components/sidebar/SidebarStateContext";

/**
 * Componente de la página de Control de Rondas.
 *
 * @returns {JSX.Element} Elemento JSX que representa la página de control de rondas.
 */
const ControlRondas = () => {
  const { collapsed } = useSidebarState();

  // Agregar una clase basada en el estado de colapso
  const containerClass = collapsed ? "controlRondasContainer collapsed" : "controlRondasContainer";

  return (
    <div className="controlRondas">
      <Sidebar />
      <div className={containerClass}>
        <Navbar />
        <RoutesModule />
      </div>
    </div>
  );
};

export default ControlRondas;